import React, {
  FunctionComponent,
  useEffect,
  useRef,
  useState,
  useCallback
} from 'react';
import styles from './checkbox.module.scss';

export interface ICheckboxProps {
  label: string;
  image?: string;
  name: string;
  required?: boolean;
  value?: boolean | string;
  className?: string;
  onChange?: (event: React.SyntheticEvent) => void;
  checkIsValid?: boolean;
  displayOnInput?: boolean;
  formIsTouched?: boolean;
  tooltipText?: string;
  smallText?: boolean;
}

export const CheckboxComponent: FunctionComponent<ICheckboxProps> = ({
  label,
  value,
  required,
  name,
  className,
  onChange,
  smallText,
  checkIsValid,
  displayOnInput,
  formIsTouched
}) => {
  const [isValid, setIsValid] = useState(true);
  const input = useRef<HTMLInputElement | null>(null);

  const checkValidity = useCallback(() => {
    input.current && checkIsValid && setIsValid(input.current.checkValidity());
  }, [checkIsValid]);

  useEffect(() => {
    checkValidity();
  }, [checkIsValid, checkValidity, isValid]);

  return (
    <label
      className={`${styles.checkbox} 
        ${className && className} 
        ${displayOnInput && styles.hide} 
        ${displayOnInput && formIsTouched && styles.show}
        ${smallText && styles.smallText}`}
      onClick={checkValidity}
    >
      {label}
      <input
        ref={input}
        className={styles.nativeCheckbox}
        required={required}
        checked={Boolean(value)}
        type="checkbox"
        onChange={onChange}
        name={name}
      />
      <span
        className={`${styles.checkmark} ${!isValid && styles.invalid}`}
      ></span>
    </label>
  );
};

export const Checkbox = React.memo(CheckboxComponent);
